<template>
  <el-button :type="type?type:'primary'" size="mini"  @click="childclick" :loading="downloadLoading" icon="el-icon-download">
    <slot>下载</slot>
  </el-button>
</template>

<script>
import { devEnvironment, proEnvironment } from '@/assets/js/division';
import {aesEncrypt} from '@/utils/aes.js';
export default {
  components: {},
  props: { attachMentId: String, downloadLoading: Boolean,type:String },
  data() {
    return { baseURL: '', aesEncrypt: aesEncrypt };
  },
  created() {},
  mounted() {},
  methods: {
    // 加密后的文件路径
    encryptFileUrl(attachMentId) {
      const enAttachMentId = this.aesEncrypt(attachMentId);
      const strText = this.aesEncrypt(`${this.token},${attachMentId}`);
      const times = this.aesEncrypt(new Date().getTime().toString());
      const imgEnUrl = `${this.baseURL}importantDocByNewController.assx/checkImportantDoc?token=${this.token}&attachMentId=${enAttachMentId}&strText=${strText}&times=${times}`;
      return imgEnUrl;
    },
    childclick() {
      if (this.attachMentId) {
        if (process.env.NODE_ENV === 'development') {
          this.baseURL = devEnvironment;
        } else if (process.env.NODE_ENV === 'production') {
          this.baseURL = proEnvironment;
        }
        // 参数加密之后的路径
        const url = this.encryptFileUrl(this.attachMentId)
        //浏览器兼容性
        const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        if (userAgent.indexOf('Firefox') > -1) {
          var a = document.createElement('a');
          a.download = name + '.xls';
          a.setAttribute('id', 'abc');
          a.href = url;
          document.getElementsByTagName('body')[0].appendChild(a); // 修复firefox中无法触发click
          a.click();
          var idObject = document.getElementById('abc');
          if (idObject !== null) idObject.parentNode.removeChild(idObject);
        } else {
          const a = document.createElement('a'); // 创建a标签
          a.setAttribute('download', ''); // download属性
          a.setAttribute('href', url); // href链接
          a.click(); // 自执行点击事件
        }
      } else {
        this.$emit('click'); //不传入Id的在自己的函数里面特殊处理
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>